import { intervalToDuration } from "date-fns";

export const printableOnlyDate = (d: any): string => {
  if (!d) return "";
  const date = new Date(d);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

// Helper function to format any date (string or Date object) for <input type="date" />
export const formatDateForInput = (dateInput: any): string => {
  if (!dateInput) return "";

  const dateObj =
    dateInput instanceof Date
      ? dateInput
      : typeof dateInput === "string"
      ? new Date(dateInput)
      : null;

  if (!dateObj || isNaN(dateObj.getTime())) return "";

  // Format as YYYY-MM-DD
  return dateObj.toISOString().split("T")[0];
};

export const calculateDiff = (serviceFrom: any, serviceTo: any): string => {
  const from = new Date(serviceFrom);
  const to = new Date(serviceTo);

  // 1. Input Validation
  if (isNaN(from.getTime()) || isNaN(to.getTime())) {
    return "Invalid Date";
  }

  // Ensure the 'from' date is before the 'to' date for intervalToDuration
  const start = from < to ? from : to;
  const end = from < to ? to : from;

  // 2. Calculate Calendar-Accurate Duration
  const duration = intervalToDuration({ start, end });

  // 3. Format Output (Use 0 for missing fields)
  const years = duration.years || 0;
  const months = duration.months || 0;
  const days = duration.days || 0;

  return `${years} years, ${months} months, ${days} days`;
};
